import { Divider, Select, Stack } from "@mantine/core";
import { Loading, PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC, useEffect, useState } from "react";
import { usePermissions } from "utils/hooks/request/usePermission";
import { RolePermissionEditor } from "./components/RolePermissionEditor/RolePermissionEditor";
import { useDetailPermission } from "utils/hooks/request/useDetailPermission";
import { PERMISSION_OPTIONS } from "constants/common/permission";
import { useDispatch } from "react-redux";
import { checkSession } from "redux/auth/slice";
import { UpdateRolePermissionPayload } from "constants/types/permission";
import { permissionApi } from "apis/permissionApi";
import { useNotification } from "utils/hooks";
import CustomText from "components/ui/CustomText/CustomText";

const PermissionWebLayout: FC = () => {
  const [search, setSearch] = useState<string | null>(null);
  const dispatch = useDispatch();
  const { notification } = useNotification();

  const { permission, error } = usePermissions();
  const {
    detailPermission,
    error: permissionErr,
    isLoading: permissionIsLoading,
    mutate: permissionMutate,
  } = useDetailPermission({ role: search || "" });

  useEffect(() => {
    if (permissionErr || error) {
      dispatch(checkSession());
    }
  }, [permissionErr, error, dispatch]);

  const handleSave = async (payload: UpdateRolePermissionPayload) => {
    try {
      await permissionApi.updateRolePermissions(payload);
      permissionMutate();
      notification.success({ title: "Cập nhật quyền thành công" });
    } catch (error) {
      notification.error({ title: "Có lỗi xảy ra khi cập nhật quyền" });
    }
  };

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: "Quản lý quyền", href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <Select
            label={
              <CustomText variant="section-title">
                Cập nhật quyền người dùng
              </CustomText>
            }
            placeholder="Chọn quyền người dùng"
            value={search}
            w={300}
            data={PERMISSION_OPTIONS}
            onChange={setSearch}
            clearable // Hiển thị nút X để xóa nhanh
            nothingFoundMessage="Không tìm thấy kết quả..."
          />
          <Divider />
          <Loading variant="overlay" visible={permissionIsLoading}>
            <RolePermissionEditor
              allPermissions={permission!}
              currentRolePermissions={detailPermission!}
              role={search!}
              onSave={handleSave}
            />
          </Loading>
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default PermissionWebLayout;
